<template>
  <div class="list">
    <div class="item" v-for="item in list" :key="item.id">
      <div class="newsDate">
        <div class="date">
          {{ item.createDate | parseTime("{mm}-{dd}") }}
        </div>
        <div class="year">{{ item.createDate | parseTime("{yyyy}") }}</div>
      </div>
      <div class="detail">
        <div class="news_title" @click="handleDetail(item.id)">
          {{ item.title }}
        </div>
        <div class="news_content" v-html="item.synopsis">
          <!-- 近日,为推动人力资源信息防伪溯源的发展和提高社会人力资源利用水平,国家市场监督管理总局指导建立的全国产品防伪溯源验证公共平台提出了【溯源优才计划】,搭建“全国人力资源信息...验证平台”和“溯源优才服务平台”,从教育过程... -->
        </div>
        <button class="btn_read" @click="handleDetail(item.id)">
          阅读全文>
        </button>
      </div>
    </div>
    <div class="text-right">
      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="listQuery.current"
        :limit.sync="listQuery.size"
        class="no-print"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { newsList } from "@/api/news";
import Pagination from "../../components/Pagination.vue";
export default {
  components: { Pagination },
  data() {
    return {
      total: 0,
      listQuery: {
        current: 1,
        size: 10,
        type: 0
      },
      list: []
    };
  },
  created() {
    this.listQuery.type = this.$route.query.type;
    this.getList();
  },
  methods: {
    getList() {
      newsList(this.listQuery).then(res => {
        // console.log(res);
        this.list = res.data.d.records;
        this.total = res.data.d.total;
      });
    },
    handleDetail(id) {
      this.$router.push({
        path: "/news/detail",
        query: { id, type: this.listQuery.type }
      });
    }
  },
  watch: {
    $route: {
      handler(val) {
        // console.log(val);
        this.listQuery.type = val.query.type;
        this.getList();
      },
      deep: true
    }
  }
};
</script>

<style scoped lang="scss">
.list {
  width: 100%;
  .text-right {
    float: right;
  }
  .item {
    width: 100%;
    display: flex;
    border-bottom: 1px solid #f0f2f5;
    padding-bottom: 50px;
    &:not(:first-child) {
      padding-top: 50px;
    }
    .newsDate {
      width: 92px;
      height: 92px;
      border: 2px solid #f0f2f5;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 10px;
      box-sizing: border-box;
      margin-right: 50px;
      //   margin-left: 100px;
      .date {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #393939;
        // line-height: 68px;
      }
      .year {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #a2a2a2;
        // line-height: 48px;
      }
    }
    .detail {
      flex: 1;
      .news_title {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #3a61b1;
        line-height: 50px;
        cursor: pointer;
      }
      .news_content {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6e6e6e;
        // line-height: 24px;
        margin-bottom: 20px;
      }
      .btn_read {
        width: 80px;
        height: 27px;
        background: #ffffff;
        border: 1px solid #3a61b1;
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #3a61b1;
        cursor: pointer;
        &:hover{
          background: #3a61b1;
          color: #fff;
        }
        // line-height: 50px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news/list.vue